const SETTINGS_TYPES = {
  // Widget Customization
  FETCH_WIDGET_SETTINGS_START: 'FETCH_WIDGET_SETTINGS_START',
  POST_WIDGET_SETTINGS_START: 'POST_WIDGET_SETTINGS_START',

  SET_WIDGET_ALL_SETTINGS: 'SET_WIDGET_ALL_SETTINGS',
  LOADING_WIDGET_ALL_SETTINGS: 'LOADING_WIDGET_ALL_SETTINGS',
  SET_WIDGET_SETTINGS_IS_SUBMITTING: 'SET_WIDGET_SETTINGS_IS_SUBMITTING',
  SET_PREV_SETTINGS: 'SET_PREV_SETTINGS',

  SET_WIDGET_LANDING: 'SET_WIDGET_LANDING',
  SET_WIDGET_STYLES: 'SET_WIDGET_STYLES',
  SET_WIDGET_VIEW_SETTINGS: 'SET_WIDGET_VIEW_SETTINGS',
  SET_DOMAINS: 'SET_DOMAINS',
  SET_POSITION: 'SET_POSITION',

  // auto messages
  FETCH_AUTO_MESSAGES: 'FETCH_AUTO_MESSAGES',
  SET_AUTO_MESSAGES: 'SET_AUTO_MESSAGES',
  SET_SELECTED_AUTO_MESSAGE: 'SET_SELECTED_AUTO_MESSAGE',
  SET_SELECTED_AUTO_MESSAGE_ERROR: 'SET_SELECTED_AUTO_MESSAGE_ERROR',
  PUBLISH_SELECTED_AUTO_MESSAGE: 'PUBLISH_SELECTED_AUTO_MESSAGE',
  TOGGLE_AUTO_MESSAGE_STATUS: 'TOGGLE_AUTO_MESSAGE_STATUS',
  DELETE_AUTO_MESSAGE: 'DELETE_AUTO_MESSAGE',
  DETERMINE_SELECTED_AUTO_MESSAGE: 'DETERMINE_SELECTED_AUTO_MESSAGE',
  SAVE_AUTO_MESSAGE_AND_RETURN: 'SAVE_AUTO_MESSAGE_AND_RETURN',
  EDIT_AUTO_MESSAGE: 'EDIT_AUTO_MESSAGE',
  SET_AUTO_MESSAGES_LOADING: 'SET_AUTO_MESSAGES_LOADING',
  RESET_SELECTED_MSG_STATE_TO_INITIAL: 'RESET_SELECTED_MSG_STATE_TO_INITIAL',
  CHANGE_MESSAGE_SENDER: 'CHANGE_MESSAGE_SENDER',

  // office hours
  FETCH_OFFICE_HOURS_SETTINGS: 'FETCH_OFFICE_HOURS_SETTINGS',
  SET_OFFICE_HOURS_SETTINGS: 'SET_OFFICE_HOURS_SETTINGS',
  ADD_NEW_WORK_TIME_SELECTION: 'ADD_NEW_WORK_TIME_SELECTION',
  REMOVE_WORK_TIME_SELECTION: 'REMOVE_WORK_TIME_SELECTION',
  SAVE_OFFICE_HOURS_SETTINGS: 'SAVE_OFFICE_HOURS_SETTINGS',

  // emails
  FETCH_EMAILS_SETTINGS: 'FETCH_EMAILS_SETTINGS',
  SET_EMAIL_SETTINGS: 'SET_EMAIL_SETTINGS',
  SAVE_EMAIL_SETTINGS: 'SAVE_EMAIL_SETTINGS',

  // general
  FETCH_GENERAL_SETTINGS: 'FETCH_GENERAL_SETTINGS',
  SET_GENERAL_SETTINGS: 'SET_GENERAL_SETTINGS',
  SAVE_GENERAL_SETTINGS: 'SAVE_GENERAL_SETTINGS',

  // response delay
  GET_RESPONSE_DELAY_DATA: 'GET_RESPONSE_DELAY_DATA',
  GET_RESPONSE_DELAY_DATA_SUCCESS: 'GET_RESPONSE_DELAY_DATA_SUCCESS',
  GET_RESPONSE_DELAY_DATA_FAILURE: 'GET_RESPONSE_DELAY_DATA_FAILURE',

  PUT_RESPONSE_DELAY_DATA: 'PUT_RESPONSE_DELAY_DATA',
  PUT_RESPONSE_DELAY_DATA_SUCCESS: 'PUT_RESPONSE_DELAY_DATA_SUCCESS',
  PUT_RESPONSE_DELAY_DATA_FAILURE: 'PUT_RESPONSE_DELAY_DATA_FAILURE',

  POST_RESPONSE_DELAY_DATA: 'POST_RESPONSE_DELAY_DATA',
  POST_RESPONSE_DELAY_DATA_SUCCESS: 'POST_RESPONSE_DELAY_DATA_SUCCESS',
  POST_RESPONSE_DELAY_DATA_FAILURE: 'POST_RESPONSE_DELAY_DATA_FAILURE',

  DELETE_RESPONSE_DELAY_DATA: 'DELETE_RESPONSE_DELAY_DATA',
  DELETE_RESPONSE_DELAY_DATA_SUCCESS: 'DELETE_RESPONSE_DELAY_DATA_SUCCESS',
  DELETE_RESPONSE_DELAY_DATA_FAILURE: 'DELETE_RESPONSE_DELAY_DATA_FAILURE',
  // form generator
  FORM_GENERATOR_POST_DATA: 'FORM_GENERATOR_POST_DATA',
  FORM_GENERATOR_POST_DATA_SUCCESS: 'FORM_GENERATOR_POST_DATA_SUCCESS',
  FORM_GENERATOR_POST_DATA_FAILURE: 'FORM_GENERATOR_POST_DATA_FAILURE',

  // RESPONSIVE ROBOT
  RESPONSIVE_ROBOT_GET_DATA: 'RESPONSIVE_ROBOT_GET_DATA',
  RESPONSIVE_ROBOT_GET_DATA_SUCCESS: 'RESPONSIVE_ROBOT_GET_DATA_SUCCESS',
  RESPONSIVE_ROBOT_GET_DATA_FAILURE: 'RESPONSIVE_ROBOT_GET_DATA_FAILURE',

  RESPONSIVE_ROBOT_DELETE_DATA: 'RESPONSIVE_ROBOT_DELETE_DATA',
  RESPONSIVE_ROBOT_DELETE_DATA_SUCCESS: 'RESPONSIVE_ROBOT_DELETE_DATA_SUCCESS',
  RESPONSIVE_ROBOT_DELETE_DATA_FAILURE: 'RESPONSIVE_ROBOT_DELETE_DATA_FAILURE',

  RESPONSIVE_ROBOT_PUT_DATA: 'RESPONSIVE_ROBOT_PUT_DATA',
  RESPONSIVE_ROBOT_PUT_DATA_SUCCESS: 'RESPONSIVE_ROBOT_PUT_DATA_SUCCESS',
  RESPONSIVE_ROBOT_PUT_DATA_FAILURE: 'RESPONSIVE_ROBOT_PUT_DATA_FAILURE',

  RESPONSIVE_ROBOT_POST_DATA: 'RESPONSIVE_ROBOT_POST_DATA',

  CHANGE_AI_BOT_ENABLED_STATUS: 'CHANGE_AI_BOT_ENABLED_STATUS',

  SET_AI_BOT_STATUS: 'SET_AI_BOT_STATUS',

  FETCH_AI_BOT_SETTINGS: 'FETCH_AI_BOT_SETTINGS',
};

export default SETTINGS_TYPES;
